import { render, staticRenderFns } from "./AppointMaterialsTransfer.vue?vue&type=template&id=a6fd2e1e&scoped=true&"
import script from "./AppointMaterialsTransfer.vue?vue&type=script&lang=js&"
export * from "./AppointMaterialsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./AppointMaterialsTransfer.vue?vue&type=style&index=0&id=a6fd2e1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fd2e1e",
  null
  
)

export default component.exports